/* loading-button.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./loading-button.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import { useIsMacro } from '../../utils/useIsMacro';
import { adaptEventHandler } from '../../utils';
import React from 'react';
import { LoadingButton as PlatformLoadingButton } from '@atlaskit/button';
var buttonStyle = null;
/**
 * A button that shows an spinner as an overlay on the button when you set an isLoading prop to true.
 */
export var LoadingButton = function LoadingButton(props) {
  var _ref = props.forgeDoc.props,
    appearance = _ref.appearance,
    autoFocus = _ref.autoFocus,
    isDisabled = _ref.isDisabled,
    isSelected = _ref.isSelected,
    onBlur = _ref.onBlur,
    onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    spacing = _ref.spacing,
    testId = _ref.testId,
    shouldFitContainer = _ref.shouldFitContainer,
    type = _ref.type,
    isLoading = _ref.isLoading;
  var isMacro = useIsMacro();
  return /*#__PURE__*/React.createElement("div", {
    className: ax([isMacro && "_11c82smr"])
  }, /*#__PURE__*/React.createElement(PlatformLoadingButton, {
    children: props.forgeDoc.children.map(function (c) {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: c.key
      }, props.render(c));
    }),
    appearance: appearance,
    autoFocus: autoFocus,
    isDisabled: isDisabled,
    isSelected: isSelected,
    onBlur: adaptEventHandler(onBlur),
    onClick: adaptEventHandler(onClick),
    onFocus: adaptEventHandler(onFocus),
    spacing: spacing,
    testId: testId,
    shouldFitContainer: shouldFitContainer,
    type: type,
    isLoading: isLoading
  }));
};